// Sidebar del portal Platform (Super Admin) — fuente: mockup portal-super-admin-*.html.
// Vive en /superadmin mientras el RBAC clonado ocupa /platform; en la Fase 0 (limpieza de
// rutas) el RBAC se re-homologa bajo este portal y la ruta pasa a /platform.
import { linkOptions } from '@tanstack/react-router';
import { Home, Settings, Users } from 'lucide-react';
import type { AppShellNavGroup } from '@/shared/patterns/AppShell';
import { GLOBAL_CONFIG_PERMISSIONS } from './global-config/permissions';

export const PLATFORM_PORTAL_TITLE = 'Portal Super Admin';

const section = (slug: string) =>
    linkOptions({ to: '/superadmin/$section', params: { section: slug } });

export const platformNav: AppShellNavGroup[] = [
    {
        items: [
            { label: 'Home', icon: Home, link: linkOptions({ to: '/superadmin' }), exact: true },
        ],
    },
    {
        label: 'Administración',
        items: [
            {
                slug: 'users-permissions',
                label: 'Usuarios y permisos',
                icon: Users,
                link: section('users-permissions'),
            },
            {
                slug: 'global-config',
                label: 'Configuración global',
                pageTitle: 'Configuración global · parámetros del sistema',
                icon: Settings,
                link: linkOptions({ to: '/superadmin/global-config' }),
                permission: GLOBAL_CONFIG_PERMISSIONS.read,
                status: 'connected',
            },
        ],
    },
];
